import React from "react";

import { useMount } from "src/helpers/hooks";
import { Portal } from "src/components/Portal";
import { ModalLayout } from "./ModalLayout";

type Props = {
  children: React.ReactNode;
  isOpened: boolean;
  closeModal: (event: any) => void;
  sx?: React.CSSProperties;
  className?: string;
  /** For a modal that draws its own close cross (e.g. CancelKeywordModal). */
  hideCloseButton?: boolean;
};

export const BasicModal = ({
  children,
  closeModal,
  isOpened,
  sx,
  className,
  hideCloseButton,
}: Props) => {
  const { mounted } = useMount({ isOpened });

  if (!mounted) {
    return null;
  }

  return (
    <Portal>
      <ModalLayout
        sx={sx}
        className={className}
        hideCloseButton={hideCloseButton}
        isOpened={isOpened}
        closeModal={closeModal}
      >
        {children}
      </ModalLayout>
    </Portal>
  );
};
